/* SwarnHouse: macOS-style liquid glass lens for the desktop menu.
   - Top tabs: one glass pill glides to the hovered / focused tab.
   - Dropdown + mega menus: each open panel gets its own glass pill that glides
     between its items (2 Feet, 3 Feet, ...).
   The pill squeezes while pressed. */
(function () {
  if (window.__shGlassNav) return;
  window.__shGlassNav = true;

  var desktop = window.matchMedia('(min-width: 1025px)');
  var SKIP = '#item_drop_HgwT7T'; /* the Weekly Deal tab has its own special look */
  var SUB_LINK = '.t4s-menu-item > a, .t4s-sub-column li > a';

  function init() {
    var ul = document.querySelector('.t4s-navigation .t4s-nav__ul');
    if (!ul || ul.__shGlass) return;
    ul.__shGlass = true;

    var host = ul.closest('.t4s-navigation') || ul.parentNode;
    var lens = document.createElement('span');
    lens.className = 'sh-glass-lens';
    lens.setAttribute('aria-hidden', 'true');
    host.insertBefore(lens, host.firstChild);
    ul.classList.add('sh-glass-on');

    var placedOnce = false;
    var current = null;

    /* ---------- top tabs ---------- */
    function topLink(node) {
      var li = node && node.closest ? node.closest('.t4s-nav__ul > li') : null;
      if (!li || li.matches(SKIP)) return null;
      return li.querySelector(':scope > a');
    }

    function restLink() {
      return ul.querySelector(':scope > li.is--nav__active > a');
    }

    function place(a) {
      if (!a || !desktop.matches) {
        lens.classList.remove('is-on');
        current = null;
        return;
      }
      var h = host.getBoundingClientRect();
      var r = a.getBoundingClientRect();
      if (!placedOnce) lens.classList.add('no-anim');
      lens.style.setProperty('--x', (r.left - h.left) + 'px');
      lens.style.setProperty('--y', (r.top - h.top) + 'px');
      lens.style.width = r.width + 'px';
      lens.style.height = r.height + 'px';
      lens.classList.add('is-on');
      if (!placedOnce) {
        void lens.offsetWidth;
        lens.classList.remove('no-anim');
        placedOnce = true;
      }
      current = a;
    }

    function settle() {
      lens.classList.remove('is-press');
      var rest = restLink();
      if (rest && !rest.closest('li').matches(SKIP)) place(rest);
      else { lens.classList.remove('is-on'); current = null; }
    }

    /* ---------- items inside dropdown / mega panels ---------- */
    function hideSub(panel) {
      var l = panel.__shLens;
      if (!l) return;
      l.classList.remove('is-on', 'is-press');
      panel.__shPlaced = false;
      panel.__shCur = null;
    }

    function subLens(panel) {
      if (!panel.__shLens) {
        var l = document.createElement('span');
        l.className = 'sh-glass-lens sh-glass-lens--sub';
        l.setAttribute('aria-hidden', 'true');
        panel.insertBefore(l, panel.firstChild);
        panel.classList.add('sh-glass-sub');
        panel.__shLens = l;
        panel.__shPlaced = false;
        panel.addEventListener('mouseleave', function () { hideSub(panel); });
        panel.addEventListener('mousedown', function (e) {
          if (e.target.closest && e.target.closest(SUB_LINK)) l.classList.add('is-press');
        });
      }
      return panel.__shLens;
    }

    function placeSub(a) {
      var panel = a.closest('.t4s-sub-menu');
      if (!panel || !desktop.matches) return;
      var l = subLens(panel);
      if (panel.__shCur === a) return;
      var h = panel.getBoundingClientRect();
      var r = a.getBoundingClientRect();
      if (!panel.__shPlaced) l.classList.add('no-anim');
      l.style.setProperty('--x', (r.left - h.left - panel.clientLeft) + 'px');
      l.style.setProperty('--y', (r.top - h.top - panel.clientTop) + 'px');
      l.style.width = r.width + 'px';
      l.style.height = r.height + 'px';
      l.classList.add('is-on');
      if (!panel.__shPlaced) {
        void l.offsetWidth;
        l.classList.remove('no-anim');
        panel.__shPlaced = true;
      }
      panel.__shCur = a;
    }

    function hideAllSubs() {
      var panels = ul.querySelectorAll('.t4s-sub-menu.sh-glass-sub');
      Array.prototype.forEach.call(panels, hideSub);
    }

    /* ---------- events ---------- */
    ul.addEventListener('mouseover', function (e) {
      var sl = e.target.closest ? e.target.closest(SUB_LINK) : null;
      if (sl && sl.closest('.t4s-sub-menu')) placeSub(sl);

      var a = topLink(e.target);
      if (a && a !== current) place(a);
      else if (!a) { lens.classList.remove('is-on'); current = null; }
    });
    ul.addEventListener('mouseleave', function () { hideAllSubs(); settle(); });
    ul.addEventListener('focusin', function (e) {
      var sl = e.target.closest ? e.target.closest(SUB_LINK) : null;
      if (sl && sl.closest('.t4s-sub-menu')) placeSub(sl);
      var a = topLink(e.target);
      if (a) place(a);
    });
    ul.addEventListener('focusout', function (e) {
      if (!ul.contains(e.relatedTarget)) { hideAllSubs(); settle(); }
    });

    ul.addEventListener('mousedown', function (e) {
      if (e.target.closest && e.target.closest(SUB_LINK)) return; /* sub panels handle their own press */
      if (topLink(e.target)) lens.classList.add('is-press');
    });
    document.addEventListener('mouseup', function () {
      var pressed = document.querySelectorAll('.sh-glass-lens.is-press');
      Array.prototype.forEach.call(pressed, function (l) { l.classList.remove('is-press'); });
    });

    window.addEventListener('resize', function () {
      if (!desktop.matches) { lens.classList.remove('is-on'); current = null; hideAllSubs(); }
      else if (current) place(current);
    });

    settle();
  }

  function run() { try { init(); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('load', run);
})();
